
// export const logout = ( state ) => {
// }

export const setClassifications = (state, classifications) => {
    state.classifications = classifications
}

export const setClassificationsSelectable = (state, classifications) => {
    state.classificationsSelectable = classifications
}

export const setClassificationsPaginated = (state, classificationsPaginatedData) => {
    state.classificationsPaginatedData = classificationsPaginatedData
}

export const setClassificationDetail = (state, classification) => {
    state.classification = classification
}

export const saveNewClassifications = (state, classification) => {
    state.classifications.unshift(classification)
    state.createdData = classification;
}

export const saveUpdatedClassification = (state, classification) => {
    state.classifications.unshift(classification)
    state.updatedData = classification;
}

export const setDeleteClassification = (state, classification) => {
    
    state.classificationsPaginatedData.data.filter(x => x.id !== classification.id);
    state.deletedData = classification
}

export const setClassificationIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setClassificationIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setClassificationIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setClassificationIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
